import React, { useState } from 'react'

import { apiFetch } from '../../helpers/meetings/api'

import { Modal, Form, Button, Select, DatePicker, Alert } from 'antd'

const ModalNewMeeting = ({ isModalOpen, onOk, onCancel, setQuarterly, setMeetingDate, setLoadData }) => {
    const [showAlert, setShowAlert] = React.useState(false);
    const [alertData, setAlertData] = React.useState({});

    const onFinish = async (values) => {
        const obj = {
            method: 'POST',
            body: {
                quarterly: values.quarterly,
                meeting_date: values.meeting_date.format('YYYY-MM-DD'),
                option: 'create_meeting',
            }
        };

        const result = await apiFetch(obj);

        if (result.status === 'success') {
            setQuarterly(values.quarterly);
            setMeetingDate(values.meeting_date.format('YYYY-MM-DD'));
            setLoadData(true);
            setShowAlert(true);
            setAlertData({
                message: "La reunión se ha creado correctamente.",
                description: "La reunión se ha creado correctamente.",
                type: "success"
            });

            setTimeout(() => {
                setShowAlert(false);
                onOk();

            }, 3000);
        } else {
            setShowAlert(true);
            setAlertData({
                message: "Error al crear la reunión",
                description: result.message || "Ha ocurrido un error al crear la reunión.",
                type: "error"
            });

            setTimeout(() => {
                setShowAlert(false);
            }, 3000);
        }
    };

    return (
        <Modal
            title="Crear nueva reunión"
            open={isModalOpen}
            onOk={onOk}
            onCancel={onCancel}
            footer={null}
        >
            <Form
                name="formNewMeeting"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete="off"
            >
                <Form.Item
                    label=""
                    name="quarterly"
                >
                    <Select
                        placeholder="Selecciona el trimestre"
                        style={{ width: '100%' }}
                        rules={[{ required: true, message: 'Por favor selecciona un trimestre' }]}
                    >
                        <Select.Option value="1">Trimestre 1</Select.Option>
                        <Select.Option value="2">Trimestre 2</Select.Option>
                        <Select.Option value="3">Trimestre 3</Select.Option>
                        <Select.Option value="4">Trimestre 4</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    label=""
                    name="meeting_date"
                    rules={[{ required: true, message: 'Por favor selecciona una fecha' }]}
                >
                    <DatePicker style={{ width: '100%' }} />
                </Form.Item>

                <Form.Item label={null}>
                    <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                        Crear reunión
                    </Button>
                </Form.Item>
            </Form>

            {showAlert &&
                <Alert
                    message={alertData.message}
                    description={alertData.description}
                    type={alertData.type}
                    showIcon
                />
            }
        </Modal>
    )
}

export default ModalNewMeeting